import React from "react";
import { createPortal } from "react-dom";
import { FONT } from "../constants";
import { C } from "../styles";

interface Props {
  open: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  deleting?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function DeleteConfirmModal({
  open,
  title,
  message,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  deleting = false,
  onConfirm,
  onCancel,
}: Props) {
  if (!open) return null;

  return createPortal(
    <div
      onClick={onCancel}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(10,26,30,.42)",
        zIndex: 2000,
        display: "grid",
        placeItems: "center",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: "24px 28px",
          maxWidth: 460,
          width: "90%",
          boxShadow: "0 24px 60px rgba(0,0,0,.3)",
          fontFamily: FONT,
        }}
      >
        <h3 style={{ fontSize: 16, fontWeight: 600, color: C.ink, marginBottom: 8 }}>
          {title}
        </h3>
        <div style={{ fontSize: 13, color: C.ink, marginBottom: 20, lineHeight: 1.55 }}>
          {message}
        </div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button
            onClick={onCancel}
            disabled={deleting}
            style={{
              background: "#fff",
              color: C.ink,
              border: "1px solid " + C.line,
              borderRadius: 6,
              padding: "9px 16px",
              fontWeight: 500,
              fontSize: 13,
              cursor: deleting ? "not-allowed" : "pointer",
              fontFamily: FONT,
            }}
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            disabled={deleting}
            style={{
              background: "#B53B2E",
              color: "#fff",
              border: 0,
              borderRadius: 6,
              padding: "9px 20px",
              fontWeight: 500,
              fontSize: 13,
              cursor: deleting ? "not-allowed" : "pointer",
              fontFamily: FONT,
              opacity: deleting ? 0.7 : 1,
            }}
          >
            {deleting ? "Deleting..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}